<template>
  <div class="ZX">
    <div class="nei_container">
      <div class="text_c">
        <div class="index_title">
          <div class="index_ts">建筑设计依据</div>
        </div>
      </div>
      <div class="newsbox">
        <div
          class="newsbox_li clearfix"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="newsbox_litxt" @click="handleHref(item)">
            <div class="t">
              <p title="点击查看"><i class="square"></i>{{ item }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    axios.get("/jz/jz.json").then((result) => {
      this.list = result.data;
      console.log("result:", result);
    });
  },
  methods: {
    handleHref(item) {
      const passSession = sessionStorage.getItem("pass");
      if (passSession == "true") {
        window.open(`/jz/${item}`, "_blank");
      } else {
        const pass = window.prompt("请输入密码", "");
        if (pass == "wjjx-2021") {
          sessionStorage.setItem("pass", "true");
          console.log("pass:", pass);
          window.open(`/jz/${item}`, "_blank");
        } else if (pass != null) {
          alert("输入密码错误");
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.ZX {
  .nei_container {
    margin: 25px auto;
    width: 1200px;
    .text_c {
      text-align: center;
      .index_title {
        font-size: 30px;
        line-height: 50px;
        position: relative;
        text-align: center;
        &::before {
          display: block;
          height: 1px;
          top: 50%;
          width: 100%;
          left: 0px;
          background: #d7d7d7;
          position: absolute;
          content: "";
        }
        .index_ts {
          display: inline-block;
          font-size: 24px;
          background: #fff;
          padding: 0px 50px;
          position: relative;
          z-index: 1;
        }
        .index_tp {
          display: inline-block;
          font-size: 18px;
          background: #fff;
          padding: 0px 50px;
          position: relative;
          z-index: 1;
          color: #ccc;
          margin-top: -5px;
        }
      }
    }
    .newsbox {
      margin: 20px auto;
      // padding: 20px 0px;
      display: flex;
      flex-wrap: wrap;
      .newsbox_litxt {
        p {
          font-size: 14px;
          color: #000;
        }
      }
      .newsbox_li {
        // padding-bottom: 10px;
        // border-bottom: 1px solid #d7d7d7;
        cursor: pointer;
        width: 50%;
        color: #575757;
        font-size: 12px;
        .newsbox_liimg {
          width: 225px;
          float: left;
          img {
            display: block;
            width: 100%;
          }
        }
        .newsbox_litxt {
          &:hover {
            color: rgba(29, 89, 144, 0.8);
          }
          // margin-left: 260px;
          .t {
            font-size: 16px;
            font-weight: bold;
            height: 30px;
            line-height: 30px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .date {
            margin: 5px 0px;
            font-size: 14px;
            color: #999;
          }
          .c {
            margin: 10px 0px;
            font-size: 14px;
            line-height: 22px;
            color: #666;
            height: 44px;
            overflow: hidden;
          }
          .newsbox_a {
            display: block;
            width: 85px;
            height: 25px;
            border: 1px solid #1a6fc9;
            font-size: 14px;
            line-height: 25px;
            color: #1a6fc9;
            text-align: center;
            text-decoration: none;
          }
        }
      }
    }
  }
  .square {
    display: inline-block;
    width: 5px;
    height: 5px;
    background-color: #c7c7c7;
    margin-right: 8px;
    position: relative;
    top: -2px;
  }
}
</style>